import { useEffect, useState } from "react";
import type { LondonNow } from "./openingHours";
import { londonNow } from "./openingHours";

const REFRESH_MS = 60_000;

/** London wall time, recomputed every 60s so the hours status flips without a reload (spec 5.1). */
export function useLondonNow(): LondonNow {
  const [now, setNow] = useState(() => londonNow());

  useEffect(() => {
    const id = setInterval(() => {
      setNow(londonNow());
    }, REFRESH_MS);
    return () => {
      clearInterval(id);
    };
  }, []);

  return now;
}
